import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Navbarsticky from "./NavbarSticky";
import Footer from "./Footer";
import { requestLoginOtp } from "../store/slices/auth"; //  IMPORTANT

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, error } = useSelector((state) => state.auth);

  const [form, setForm] = useState({
    uname: "",
  });

  const [errors, setErrors] = useState({});

  /* ---------------- HANDLE CHANGE ---------------- */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ [name]: value });
    setErrors({});
  };

  /* ---------------- VALIDATION ---------------- */
  const validate = () => {
    if (!form.uname.trim()) {
      setErrors({ uname: "Enter email or mobile number" });
      return false;
    }
    return true;
  };

  /* ---------------- SEND OTP ---------------- */
  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) return;
    if (!validate()) return;

    dispatch(requestLoginOtp({ uname: form.uname }))
      .unwrap()
      .then(() => {
        sessionStorage.setItem("otp_uname", form.uname);
        navigate("/verifyOtp", {
          state: {
            uname: form.uname, // optional but good UX
          },
        });
      })
      .catch(() => {
        // error handled via redux
      });
  };

  return (
    <>
      <Navbarsticky />
      <div className="auth-container"></div>

      <div className="auth-page">
        <div className="auth-card">
          {/* LEFT SIDE */}
          <div className="auth-left">
            <div className="auth-left-top">
              <span className="auth-logo-text">ANDAMAN MAKE HOLIDAYS</span>
            </div>
            <div className="auth-left-content">
              <h2>Capturing Moments,</h2>
              <h2>Creating Memories</h2>
            </div>
          </div>

          {/* RIGHT FORM */}
          <div className="auth-form-wrapper">
            <div className="auth-form-header">
              <h1>Login with OTP</h1>
              <p>
                Don&apos;t have an account?{" "}
                <Link to="/signup" className="auth-link">
                  Sign up
                </Link>
              </p>
            </div>

            <form className="auth-form" onSubmit={handleSubmit} noValidate>
              <div className="auth-input-group full">
                <label>Email or Mobile Number</label>
                <input
                  name="uname"
                  type="text"
                  placeholder="Enter your email or mobile number"
                  value={form.uname}
                  onChange={handleChange}
                />
                {errors.uname && (
                  <span className="auth-error-text">{errors.uname}</span>
                )}
              </div>

              {error && (
                <div className="auth-error-text text-center mb-2">{error}</div>
              )}

              <button
                type="submit"
                className="auth-primary-btn"
                disabled={loading}
              >
                {loading ? "Sending OTP..." : "Send OTP"}
              </button>
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
